import {
  DOCUMENT_HISTORY,
  DOCUMENT_DATA_BY_ID,
  DOCUMENT_DATA,
  DOCUMENT_LEVEL_DATA,
  DOCUMENT_LEVEL_BY_ID,
  DISTINCT_DOCUMENT_LEVEL_DATA,
  DOCUMENT_STATUS,
  FETCH_START,
  FETCH_END,
  SEARCH_DOCUMENT_SUCESS,
  NEW_APPROVAL_DOC_DATA,
  FETCH_WORKFLOW_BY_ID_SUCCESS,
  QUERY_LIST_DATA,
  WORKFLOW_CONFIGURATION_LIST_SUCCESS
} from '../../actions/DocumentManagement/ActionTypes';

const initialState = {
  loading: false,
  documentData: [],
  documentSingleData: [],
  documentSearchData: [],
  documentLevels: {},
  documentLevelById: {},
  distinctDocumentLevel: [],
  documentStatus: {},
  documentHistory: [],
  newDocApprovalData: [],
  singleDoctData: [],
  queryList: [],
  workflowConfigurationList: [],
};

const DocumentManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case DOCUMENT_DATA:
      return {
        ...state,
        documentData: action.data,
      };
    case DOCUMENT_DATA_BY_ID:
      return {
        ...state,
        documentSingleData: action.data,
      };
    case SEARCH_DOCUMENT_SUCESS:
      return {
        ...state,
        documentSearchData: action.data,
      };
    case DOCUMENT_LEVEL_DATA:
      return {
        ...state,
        documentLevels: action.data,
      };
    case DOCUMENT_LEVEL_BY_ID:
      return {
        ...state,
        documentLevelById: action.data,
      };
    case DISTINCT_DOCUMENT_LEVEL_DATA:
      return {
        ...state,
        distinctDocumentLevel: action.data,
      };
    case NEW_APPROVAL_DOC_DATA:
      return {
        ...state,
        newDocApprovalData: action.data,
      }
    case DOCUMENT_STATUS:
      return {
        ...state,
        documentStatus: action.data,
      };
    case DOCUMENT_HISTORY:
      return {
        ...state,
        documentHistory: action.data,
      };
    case FETCH_WORKFLOW_BY_ID_SUCCESS:
      return {
        ...state,
        singleDoctData: action.payload,
      };
    case QUERY_LIST_DATA:
      return {
        ...state,
        queryList: action.data,
      };
    case WORKFLOW_CONFIGURATION_LIST_SUCCESS:
      return {
        ...state,
        workflowConfigurationList: action.data,
      };
    default:

      return state;
  }
};

export default DocumentManagementReducer;
